import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getFollowingAssets = async (id: string, search?: string) => {
  const { data: followers, error: followersError } = await supabase
    .from('following_users_assets')
    .select('*')
    .eq('user_id', id)

  if (followersError) {
    throw new Error(followersError.message)
  }

  const ids = followers.map((f) => f.asset_id)

  let req = supabase
    .from('assets')
    .select(`
      *,
      category:categories(*)
    `)
    .in('id', ids);

  if (search) {
    req = req.or(
      `name.ilike.%${search}%,ticker.ilike.%${search}%,currency_name.ilike.%${search}%`,
    )
  }

  const { data: assets } = await req.range(0, 100)

  return assets
}

export default function useFollowingAssets(id: string, search = '') {
  return useQuery({
    queryKey: ['useFollowingAssets', id],
    queryFn: () => getFollowingAssets(id, search),
    enabled: Boolean(id),
    staleTime: 60000,
  })
}
